import { createContext, useContext } from 'react';
import { makeAutoObservable } from 'mobx';

export class EmojiMenuStore {
  open = false;
  query = '';

  constructor() {
    makeAutoObservable(this);
  }

  setOpen(open: boolean) {
    this.open = open;
  }

  setQuery(query: string) {
    this.query = query;
  }

  reset() {
    this.open = false;
    this.query = '';
  }
}

export const EmojiMenuContext = createContext<EmojiMenuStore | undefined>(undefined);

export function useEmojiMenu() {
  const store = useContext(EmojiMenuContext);
  if (!store) {
    throw new Error('useEmojiMenu must be used within a EmojiMenuProvider');
  }
  return store;
}
